import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchIccParameters = () => apiActionCreator({
  'endpoint': '/parameters/iccmatrix',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ICC_PARAMETERS,
    ActionTypes.FETCHED_ICC_PARAMETERS,
    [
      ActionTypes.FETCHED_ICC_PARAMETERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const saveIccParameters = (data) => apiActionCreator({
  'endpoint': '/parameters/iccmatrix',
  'authenticated': true,
  'types': [
    ActionTypes.SAVING_ICC_PARAMETERS,
    [
      ActionTypes.SAVED_ICC_PARAMETERS,
      MessageActions.addMessageBoxInfo('Parámetros ICC actualizados satisfactoriamente'),
    ],
    [
      ActionTypes.SAVED_ICC_PARAMETERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': data,
});

export const fetchIccParametersByProvider = (providerCode) => apiActionCreator({
  'endpoint': `/providers/${providerCode}/icc-values`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ICC_PARAMETERS_BY_PROVIDER,
    ActionTypes.FETCHED_ICC_PARAMETERS_BY_PROVIDER,
    [
      ActionTypes.FETCHED_ICC_PARAMETERS_BY_PROVIDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearIccParametersByProvider = () => ({
  'type': ActionTypes.CLEAR_ICC_PARAMETERS_BY_PROVIDER,
});
